export const DATE_FORMATS = {
  short: 'MMM yyyy',       // Mar 2021
  detailed: 'MMMM yyyy',  // March 2021
  monthYear: 'MM/yyyy',   // 03/2021
  monthYearShort: 'MM/yy', // 03/21
};